var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.26 10.1796H14.0861V6.00562H9.91217V10.1796H5.73828V14.3534H9.91217V18.5273H14.0861V14.3534H18.26V10.1796Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CHF.18089548bf77cf39c8554c3c921ff275.svg";